import { AppNode } from "@features/builder/graph/types"
import { linkEncode, linkParse } from "@components/NodeLink/linkHelpers"

export function getGraphLinks(nodes: AppNode[]) {
  const linkedGraphKeys = new Set<string>()

  for (const node of nodes) {
    if (!("metaNode" in node.data)) continue
    if (!node.data.metaNode.Link?.trim()) continue

    const parsed = linkParse(node.data.metaNode.Link)
    if (!parsed) continue

    linkedGraphKeys.add(
      linkEncode(parsed.org, parsed.div, parsed.prod, parsed.family, parsed.version),
    )
  }

  return [...linkedGraphKeys]
}
